export default function FishPlaceholder() {
	return (
		<svg
			class="text-gray h-16 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
			viewBox="0 0 56 74"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="m42.658 0.89603c-0.0082-0.005964-0.0151-0.009847-0.0242-0.014363l-1e-3 -5.15e-4c-0.0512-0.025407-0.1113-0.025407-0.1625 0-0.0098 0.004858-0.017 0.009051-0.0258 0.015592-1.5771 1.1788-12.702 10.424-12.702 30.999 0 13.956 11.178 24.196 12.713 25.101 0.0605 0.03 0.1315 0.03 0.1919 0 1.5352-0.8573 12.713-11.098 12.713-25.101 0-20.579-11.082-29.824-12.702-30.999zm-0.1544 6.4225c-1.0554 0-1.919-0.85734-1.919-1.9052s0.8636-1.9052 1.919-1.9052 1.9189 0.85733 1.9189 1.9052-0.9115 1.9052-1.9189 1.9052z"
				class="fill-current"
			/>
			<path
				d="m46.251 68.551c-1.3339-3.2024-5.8706-3.2024-7.2045 0-1.0707 2.5704 0.8178 5.4028 3.6022 5.4028 2.7845 0 4.673-2.8324 3.6023-5.4028z"
				class="fill-current"
			/>
			<path
				d="m25.955 42.899c0-13.956-11.178-24.196-12.713-25.101-0.0604-0.03-0.1314-0.03-0.1919 0-1.5351 0.905-12.713 11.145-12.713 25.101 0 20.575 11.125 29.82 12.702 30.999 0.0088 0.0065 0.0161 0.0107 0.0259 0.0156 0.0511 0.0254 0.1113 0.0254 0.1624 0 0.0098-0.0049 0.0171-0.0091 0.0259-0.0156 1.5771-1.1788 12.702-10.424 12.702-30.999zm-10.986 26.435c0 1.0479-0.8635 1.9052-1.919 1.9052-1.0554 0-1.9189-0.8573-1.9189-1.9052 0-1.0478 0.8635-1.9052 1.9189-1.9052 1.0555 0 1.919 0.8574 1.919 1.9052z"
				class="fill-current"
			/>
			<path
				d="m16.844 6.2436c-1.3339 3.2024-5.8706 3.2024-7.2045 0-1.0707-2.5704 0.81782-5.4028 3.6023-5.4028 2.7844 0 4.6729 2.8325 3.6022 5.4028z"
				class="fill-current"
			/>
		</svg>
	);
}
